export class LegalQuestionFilters {
  answers?: Array<string>;

  constructor(legalQuestionFilters?: Partial<LegalQuestionFilters>) {
    Object.assign(this, legalQuestionFilters);
  }
}
